/**
 * Texts of the connection to the own backend (port addition). As everywhere in the game, the Russian text is the
 * source and the translation key (src/game/runtime/i18n.ts): game text fields translate it on assignment, the browser
 * loading screen (src/main.ts) calls `translate()`. Composed messages are built from fragments that each have a
 * catalogue entry (tools/i18n/extra.json), so the number or the address in the middle is kept as it is.
 */

// ---------------------------------------------------------------- browser loading screen (src/main.ts)
export const MSG_LOADING_ASSETS = 'Загрузка ресурсов…';
export const MSG_CONNECTING = 'Подключение к серверу…';
export const MSG_RETRY_HINT = 'Щёлкните или нажмите любую клавишу, чтобы повторить сейчас.';
export const MSG_VERSION_MISMATCH = 'Версия игры устарела. Обновите страницу.';

/**
 * "The game's server is unavailable. Retrying in N s…" (N = 0: the attempt is running): what the player reads; the
 * address it tries is a detail line under it in small print (serverAddressText).
 */
export function serverUnavailableText(seconds: number): string {
  return 'Сервер игры недоступен' + (seconds > 0 ? '. Повтор через ' + seconds + ' с…' : '. Повтор…');
}

/** The detail line under the loading screen's message: the server's address. */
export function serverAddressText(address: string): string {
  return 'Адрес сервера: ' + address;
}

export function startupFailedText(message: string): string {
  return 'Не удалось запустить игру: ' + message;
}

// ---------------------------------------------------------------- in-game (FWP backend bridge)
/** Why a blocking backend call is being retried. */
export type NetRetryReason = 'offline' | 'busy' | 'server';

/** "No connection to the server. Retrying in N s…" (N = 0: the attempt is running). */
export function netRetryText(reason: NetRetryReason, seconds: number): string {
  const what = reason === 'busy' ? 'Сервер перегружен' : reason === 'server' ? 'Ошибка сервера' : 'Нет связи с сервером';
  return what + (seconds > 0 ? '. Повтор через ' + seconds + ' с…' : '. Повтор…');
}

export const MSG_NET_RETRY_NOW = 'Щёлкните, чтобы повторить сейчас';
export const MSG_CONNECTION_LOST = 'Нет связи с сервером…';
export const MSG_CONNECTION_RESTORED = 'Связь с сервером восстановлена';
export const MSG_PROFILE_CONFLICT = 'Профиль изменён в другом окне. Загружены актуальные данные.';
export const MSG_PROFILE_UPDATED = 'Данные профиля обновлены.';
export const MSG_SESSION_EXPIRED = 'Сессия истекла. Перезапустите игру.';
/** A host without the sign-in screen (tools): the account signed in on another device, which ended this session. */
export const MSG_SESSION_REPLACED = 'Вы вошли в этот аккаунт на другом устройстве. Перезапустите игру, чтобы играть здесь.';
export const MSG_PLAYER_CHANGED = 'Вход выполнен под другим игроком. Перезапуск…';
export const MSG_RESTART = 'Перезапустить';

/** "Server error (CODE)": a failure the game cannot recover from by itself. */
export function netErrorText(code: string): string {
  return 'Ошибка сервера (' + code + ')';
}
